module.exports = "/img/_/_/_/assets/images/creeper/battle/common//26.jpg?fef274e12f4e0c8eec5c69be699b4dac";